import React, {useEffect} from 'react'
import propTypes from 'prop-types'
import {gql} from "@apollo/client";
import styled from '@emotion/styled';
import {Grid, Box} from '@mui/material';
import {get} from 'lodash';

// static functions
import client from '../../src/graphql/client';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorRepaymentCalculator from '../../src/data-restructure/pages/repayment-calculator';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';

import {theme} from '../../src/themes/default-theme';

// components
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';
import CaravanCardSelect from '../../src/components/ui/CaravanCardSelect';
import Text from '../../src/components/typography';
import seoQuery from '../../src/graphql/queries/seo';
import {sellsMotorhomes, sellsCampervans} from '../../src/util/filterDealerMotorHomes';


const CaravanCards = styled.div`
  max-width: 1200px;
  margin: 30px auto 25px;

  ${theme.breakpoints.up('md')} {
    margin: 60px auto 45px;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 115px auto 60px;
  }
`

const CaravanCardContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;

  ${theme.breakpoints.up('md')} {
    max-width: 335px;
  }
`

const Heading = styled.div`
  margin-bottom: 20px;
  ${theme.breakpoints.up('md')} {
    margin-bottom: 28px;
  }
`

const RepaymentsCalculator = (props) => {

  useEffect(() => {
    if (process.env.SHOW_PRICING === false) {
      window.location.href = '/'
    }
  }, [])

  const sellsCampers = sellsCampervans();
  const sellsMotors = sellsMotorhomes();

  console.log('repayments-calc', {props, sellsCampers, sellsMotors});

  return (
    <div>
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          headingSize="large"
        />
      }
      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }
      {props.ranges &&
        <CaravanCards>
          <Heading>
            <Text variant="h4" align="center" uppercase colour="charcoal">Choose your range</Text>
          </Heading>
          <Grid container direction={'row'} justifyContent={'flex-start'} alignItems={'flex-start'}>
            {props.ranges.map(item => {

              const driveType = item.title.toLowerCase();
              const show = (!sellsCampers && driveType === 'campervans' || !sellsMotors && driveType === 'motorhomes') ? false : true;
              const campervansOnly = process.env.DEALER_SITE && sellsMotors === false && sellsCampers !== false;

              console.log('campervansOnly', campervansOnly, item);

              if (campervansOnly && item.title && item.title.toLowerCase() === 'motorised' && item.ranges && (item.ranges.indexOf('Campervans') === -1 || item.ranges.indexOf('campervans') === -1)) {
                return null;
              }

              return (show ? <Grid
                key={item.id}
                size={{
                  xs: 12,
                  md: 6,
                  lg: 4
                }}>
                <Box px={2}>
                  <CaravanCardContainer>
                    <CaravanCardSelect
                      {...item}
                    />
                  </CaravanCardContainer>
                </Box>
              </Grid> : null);})}
          </Grid>
        </CaravanCards>
      }
    </div>
  );
}

RepaymentsCalculator.propTypes = {
}

export async function getStaticProps() {
  const GET_REPAYMENTS_CALC_PAGE = gql`
    query GET_REPAYMENTS_CALC_PAGE($uri: String, $rangeUri: String)  {
      pageBy(uri: $uri) {
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        ${contentBuilderQuery()}
      }
      series(first: 10000) {
        nodes {
          seriesId
          acf_series {
            rangeAssigned
            seriesHidePricing
          }
        }
      }
      ranges(first: 10000) {
        nodes {
          acf_domains {
            assignedDomains
          }
          title
          id
          uri
          rangeId
          acf_range {
            rangeImage {
              ${respImgQuery}
            }
          }
        }
      }
      modelsFloorPlans(first: 10000) {
        nodes {
          title
          uri
          acf_floor_plan {
            modelHidePricing
            seriesSpec
            modelSeries {
              ... on Series {
                id
                seriesId
              }
            }
          }
        }
      }
      rangeListingsPageBy(uri: $rangeUri) {
        acf_range_listings_page {
          rangeListingsPageRangeRef {
            ... on Range {
              id
              rangeId
            }
          }
        }
      }
    }
  `

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const pageProps = await client.query({
    query: GET_REPAYMENTS_CALC_PAGE,
    variables: {
      uri: `repayments-calculator?${countryCode}`,
      rangeUri: `range?${countryCode}`
    }
  });

  const data = refactorRepaymentCalculator(pageProps)

  const pageBy = pageProps ? get(pageProps, 'data.pageBy', null) : null;

  const assignedDomains = get(pageProps, 'data.pageBy.acf_domains.assignedDomains', []); 

  const breadcrumbs = await refactorBreadcrumbsData('/repayments-calculator', assignedDomains);

  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
      meta: {
        title: pageBy ? pageBy.title : null,
        seo: pageBy ? pageBy.seo : null
      },
      breadcrumbs,
      ...data,
      pageProps
    }
  }
}

export default RepaymentsCalculator